import React from 'react';
import Reflux from 'reflux';
import {
  dictionaryStore,
  dictionaryActions,
} from './store';
import { hashHistory } from 'react-router';
import { DmsTab } from 'Components';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Table,
  Select,
  message,
} from 'antd';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
import Edit from './edit.js';
import { dictionayDetail } from '../../service/dictionary';
import {
  dataitemList,
  dataitemDelete,
  dependentItemIdList,
} from '../../service/dictionary/dataitem.js';
import { config } from 'Utils';

class DictionaryDetail extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = dictionaryStore;
    this.state = {
      detail: {},
      data: [],
      allFlag: true,//从属为false,独立为false；
      detailId: this.props.params.detailId,
      opts: [],
      dependentItem: [],
      itemId: null,
    };
    this.renderColumns = this.renderColumns.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getData = this.getData.bind(this);
    this.getItemList = this.getItemList.bind(this);
    this.getDependentItemValue = this.getDependentItemValue.bind(this);
    this.goAddItem = this.goAddItem.bind(this);
  }

  componentDidMount() {
    if (this.props.params.detailId == this.state.dataId) {
      dictionaryActions.dataIdChange(parseInt(this.props.params.detailId, 0));
    } else {
      this.setState({
        itemId: null,
      });
      dictionaryActions.dependentChange(null);
      dictionaryActions.dataIdChange(parseInt(this.props.params.detailId, 0));
    }
    this.getData();
  }

//获取数据的方法
  getData() {
    var obj = {};
    obj.id = parseInt(this.state.detailId, 0);
    dictionayDetail(obj).then(result => {
      if (result.status) {
        var dataObj = result.data;
        var optsArr = [];
        optsArr.push(result.data.name);
        if (dataObj.type === 0) {
          dataitemList(obj).then(res => {
            if (res.status) {
              if (res.data && res.data != null) {
                for (var i = 0; i < res.data.length; i++) {
                  res.data[i].key = res.data[i].id;
                  res.data[i].number = i;
                  var active = res.data[i].active;
                  if (active === 1) {
                    res.data[i].active = '启用';
                  } else {
                    res.data[i].active = '禁用';
                  }
                }
                this.setState({
                  data: res.data,
                  detail: dataObj,
                  opts: optsArr,
                  allFlag: true,//决定从属数据项是否显示
                });
              } else {
                this.setState({
                  detail: dataObj,
                  opts: optsArr,
                  allFlag: true,//决定从属数据项是否显示
                });
              }
            } else {
              message.error(res.message);
            }
          });
        } else {
          dataitemList({ id: dataObj.dependentDataItemId }).then(last => {
            if (last.status) {
              if (last.data != null) {
                if (this.state.dependentId) {
                  dependentItemIdList({ id: this.state.dependentId }).then(res => {
                    if (res.status) {
                      if (res.data && res.data != null) {
                        for (var i = 0; i < res.data.length; i++) {
                          res.data[i].key = res.data[i].id;
                          res.data[i].number = i;
                          var active = res.data[i].active;
                          if (active === 1) {
                            res.data[i].active = '启用';
                          } else {
                            res.data[i].active = '禁用';
                          }
                        }
                        this.setState({
                          itemId: this.state.dependentId,
                          data: res.data,
                          dependentItem: last.data,
                          detail: dataObj,
                          opts: optsArr,
                          allFlag: false,//决定从属数据项是否显示
                        });
                      }
                    } else {
                      message.error(res.message);
                    }
                  });
                } else {
                  this.setState({
                    dependentItem: last.data,
                    detail: dataObj,
                    opts: optsArr,
                    allFlag: false,//决定从属数据项是否显示
                  });
                }
              } else {
                this.setState({
                  detail: dataObj,
                  opts: optsArr,
                  allFlag: false,//决定从属数据项是否显示
                });
              }
            } else {
              message.error(last.message);
            }
          });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  //获取itemlist
  getItemList(id) {
    var itemobj = {};
    itemobj.id = id;
    if (this.state.allFlag) {
      dataitemList(itemobj).then(res => {
        if (res.status) {
          if (res.data && res.data != null) {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].key = res.data[i].id;
              res.data[i].number = i;
              var active = res.data[i].active;
              if (active === 1) {
                res.data[i].active = '启用';
              } else {
                res.data[i].active = '禁用';
              }
            }
            this.setState({
              data: res.data,
            });
          }
        } else {
          message.error(res.message);
        }
      });
    } else {
      dependentItemIdList(itemobj).then(res => {
        if (res.status) {
          if (res.data && res.data != null) {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].key = res.data[i].id;
              res.data[i].number = i;
              var active = res.data[i].active;
              if (active === 1) {
                res.data[i].active = '启用';
              } else {
                res.data[i].active = '禁用';
              }
            }
            this.setState({
              data: res.data,
            });
          }
        } else {
          message.error(res.message);
        }
      });
    }
  }

  goAddItem() {
    const { detail, itemId, allFlag } = this.state;
    if (allFlag) {
      this.goView(`/dictionary/additem/${detail.id}-${itemId}-${allFlag}`);
    } else {
      if (itemId) {
        this.goView(`/dictionary/additem/${detail.id}-${itemId}-${allFlag}`);
      } else {
        message.info('请选择从属项值');
      }
    }
  }

  renderColumns(data, index, key, text) {
    return (<Edit
      value={text}
    />);
  }

  onDelete = (number) => {
    const { data, detail, itemId } = this.state;
    dataitemDelete(data[number].id).then(result => {
      if (result.status) {
        message.success(result.message);
        if (detail.type === 0) {
          this.getItemList(detail.id);
        } else {
          this.getItemList(itemId);
        }
      } else {
        message.error(result.message);
      }
    });
  };

  //返回
  cancelHandle() {
    this.goView('/dictionary');
  }

  //获取从属数据项值下的值
  getDependentItemValue(value) {
    this.setState({
      itemId: parseInt(value, 0),
    });
    this.getItemList(parseInt(value, 0));
    dictionaryActions.dependentChange(parseInt(value, 0));
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  render() {
    const { opts, detail, allFlag, data } = this.state;
    const { getFieldDecorator } = this.props.form;
    const inputstyle = {
      border: 'none',
      borderBottom: '1px solid #ccc',
      background: '#fff',
      color: '#333',
    };
    const tablevalue = {
      pagination: false,
      size: 'small',
      bordered: true,
      columns: [
        {
          title: '',
          dataIndex: 'number',
          width: 100,
          render: (text, record, index) => text + 1,
        }, {
          title: '值',
          dataIndex: 'sKey',
          // width: '30%',
          render: (text, record, index) => this.renderColumns(this.state.data, index, 'sKey', text),
        }, {
          title: '名称',
          dataIndex: 'name',
          // width: '15%',
          render: (text, record, index) => this.renderColumns(this.state.data, index, 'name', text),
        }, {
          title: '对应图片',
          dataIndex: 'filePath',
          width: 150,
          render: (text, record, index) => text ? <img style={{width: 120, height: 120}} src={`${config.server}/${text}`} /> : null,
        }, {
          title: '状态',
          dataIndex: 'active',
          width: 60,
          render: (text, record, index) => this.renderColumns(this.state.data, index, 'active', text),
        }, {
          title: '排序',
          dataIndex: 'sortOrder',
          width: 60,
          render: (text, record, index) => this.renderColumns(this.state.data, index, 'sortOrder', text),
        }, {
          title: '操作',
          dataIndex: 'operation',
					width: 120,
          render: (text, record, index) => {
            return <div className="editable-row-operations">
              <a onClick={this.goView.bind(this, `/dictionary/additem/${record.id}+${detail.dependentDataItemId}-${detail.name}`)}>编辑</a>
              <a onClick={() => this.onDelete(record.number)}>删除</a>
            </div>;
          },
        },
      ],
    };
    return <div className='dms-body'>

      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>返回</Button>
        <Button icon="edit" onClick={this.goView.bind(this, `/dictionary/add/${detail.id}`)}>编辑</Button>
        <Button icon="plus"
                onClick={this.goAddItem}>数据项值</Button>

      </DmsTab>
      <div className="dms-table-box" style={{ backgroundColor: '#fff' }}>
        <Form layout="horizontal">
          <Row gutter={100}>
            <Col className="gutter-row" span={12}>
              <FormItem label="数据项Key">
                {getFieldDecorator('sKey', {
                  initialValue: (detail !== null && detail.sKey) ? detail.sKey : '',
                })(<Input disabled={true} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="有效性">
                {getFieldDecorator('active', {
                  initialValue: (detail !== null && detail.active === 0) ? '0' : '1',
                })(<Select disabled>
                  <Option value='1'>有效</Option>
                  <Option value='0'>无效</Option>
                </Select>)}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={100}>
            <Col className="gutter-row" span={12}>
              <FormItem label="类型">
                {getFieldDecorator('type', {
                  initialValue: (detail !== null && detail.type === 1) ? '1' : '0',
                })(<Select disabled>
                  <Option value='1'>从属</Option>
                  <Option value='0'>独立</Option>
                </Select>)}
              </FormItem>
            </Col>
            {
              allFlag ?
                ''
                :
                <Col className="gutter-row" span={12}>
                  <FormItem label="从属数据项" style={{ display: this.state.allShow }}>
                    {getFieldDecorator('dependentDataItemName', {
                      initialValue: (detail !== null && detail.dependentDataItemName) ? detail.dependentDataItemName : '',
                    })((<Input disabled />))}
                  </FormItem>
                </Col>
            }
          </Row>

          <Row>
            <FormItem label="描述">
              {getFieldDecorator('description', {
                initialValue: (detail !== null && detail.description) ? detail.description : '-',
              })(<TextArea rows={4} disabled style={inputstyle} />)}
            </FormItem>
          </Row>

          {
            allFlag ?
              ''
              :
              <Row>
                <Col className="gutter-row" span={12}></Col>
                <Col className="gutter-row" span={12}>
                  <FormItem label="从属数据项值">
                    {getFieldDecorator('dependentId', {
                      initialValue: (this.state.dependentId) ? this.state.dependentId.toString() : '',
                    })(<Select
                      onChange={this.getDependentItemValue}
                      placeholder='请选择从属数据项值'
                    >
                      {
                        this.state.dependentItem.map(function (item, key) {
                          return <Option value={(item.id).toString()}
                                         key={key}>{item.name}</Option>;
                        })
                      }
                    </Select>)}
                  </FormItem>
                </Col>
              </Row>
          }


          <Row>
            <FormItem label="数据项值" style={{ display: this.state.allShow }}>
              <Table {...tablevalue} dataSource={data} />
            </FormItem>
          </Row>

        </Form>
      </div>

    </div>;
  }
}

export default Form.create()(DictionaryDetail);



// WEBPACK FOOTER //
// ./src/routes/dictionary/detail.js